var map = {
	"./01-smc.jpg": "./src/img/logos/01-smc.jpg",
	"./02-smfb.jpg": "./src/img/logos/02-smfb.jpg",
	"./03-smbi.jpg": "./src/img/logos/03-smbi.jpg",
	"./04-smtf.jpg": "./src/img/logos/04-smtf.jpg",
	"./05-smpi.jpg": "./src/img/logos/05-smpi.jpg",
	"./06-petrogen.jpg": "./src/img/logos/06-petrogen.jpg",
	"./07-aibc.jpg": "./src/img/logos/07-aibc.jpg",
	"./08-smgp.jpg": "./src/img/logos/08-smgp.jpg",
	"./09-prosync.jpg": "./src/img/logos/09-prosync.jpg",
	"./10-pal.jpg": "./src/img/logos/10-pal.jpg",
	"./11-mabuhay.jpg": "./src/img/logos/11-mabuhay.jpg",
	"./12-kia.jpg": "./src/img/logos/12-kia.jpg",
	"./13-maxus.jpg": "./src/img/logos/13-maxus.jpg",
	"./14-redlab.jpg": "./src/img/logos/14-redlab.jpg",
	"./15-gemik.jpg": "./src/img/logos/15-gemik.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/logos sync \\.(png%7Cjpe?g%7Csvg)$";